import { useToggleState } from '@sg/garnish';

/**
 * On web this is just a toggle as it's presented as a component.
 */
export const useCustomerSheet = (_props: UseCustomerSheetProps) => {
  const {
    value: isShowingCustomerSheet,
    toggleOn: showCustomerSheet,
    toggleOff: hideCustomerSheet,
  } = useToggleState();

  return {
    isShowingCustomerSheet,
    showCustomerSheet,
    hideCustomerSheet,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseCustomerSheetProps = {
  onSuccess: () => void;
};
